/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitTag,
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import {
    PressKitThumbnailUrls,
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * 
 * @export
 * @interface PressKitLogoListByCompanyIdResults
 */
export interface PressKitLogoListByCompanyIdResults {
    /**
     * PressKit Logo UUID(v4)
     * @type {string}
     * @memberof PressKitLogoListByCompanyIdResults
     */
    id: string;
    /**
     * 企業が登録したファイルの名前（キャプション）
     * @type {string}
     * @memberof PressKitLogoListByCompanyIdResults
     */
    title: string;
    /**
     * ファイル拡張子（原則英語小文字）
     * @type {string}
     * @memberof PressKitLogoListByCompanyIdResults
     */
    extension: PressKitLogoListByCompanyIdResultsExtensionEnum;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitLogoListByCompanyIdResults
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * 画像のダウンロード用URL。別ドメイン。
     * @type {string}
     * @memberof PressKitLogoListByCompanyIdResults
     */
    downloadUrl: string;
    /**
     * 企業が設定しているタグの一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitLogoListByCompanyIdResults
     */
    readonly tags: Array<PressKitTag>;
}

/**
* @export
* @enum {string}
*/
export enum PressKitLogoListByCompanyIdResultsExtensionEnum {
    Jpg = 'jpg',
    Png = 'png'
}

export function PressKitLogoListByCompanyIdResultsFromJSON(json: any): PressKitLogoListByCompanyIdResults {
    return PressKitLogoListByCompanyIdResultsFromJSONTyped(json, false);
}

export function PressKitLogoListByCompanyIdResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitLogoListByCompanyIdResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'extension': json['extension'],
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitLogoListByCompanyIdResultsToJSON(value?: PressKitLogoListByCompanyIdResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'extension': value.extension,
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
    };
}

